import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  token: null,
  permissions: {
    userPermissions: {
      create: false,
      import: false,
      export: false,
      read: false,
      write: false
    },
    userDetailsPermissions: {
      username: false,
      email: false,
      phoneNo: false,
      dob: false
    },
    yojnaPermissions: {
      import: false,
      export: false,
      read: false,
      write: false
    }
  },
  isAuthenticated: false
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, { payload }) => {
      const { user, token } = payload;
      state.user = user;
      state.token = token;
      state.isAuthenticated = true;
      
      // Parse and set permissions from the stringified JSON
      try {
        const privileges = JSON.parse(user.userGroup.privileges);
        state.permissions = privileges;
      } catch (error) {
        console.error('Error parsing privileges:', error);
      }
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.permissions = initialState.permissions;
      state.isAuthenticated = false;
      
      // Clear localStorage
      localStorage.removeItem('token');
      localStorage.removeItem('userPrivileges');
      localStorage.removeItem('userGroupName');
      localStorage.removeItem('user');
      localStorage.removeItem('userId');
      localStorage.removeItem('userName');
    }
  }
});

export const { setCredentials, logout } = authSlice.actions;

// Selectors
export const selectCurrentUser = (state) => state.auth.user;
export const selectCurrentToken = (state) => state.auth.token;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectUserPermissions = (state) => state.auth.permissions;

export default authSlice.reducer; 